<template>
  <div >
    <div class="main" tyle="background-image:url(static/img/act/5/banner/bg.jpg)">     
      <img src="static/img/act/5/top.jpg" />
      <router-link to="/act5/main/article">
        <img src="static/img/act/5/1.jpg"  />
      </router-link>
      <img src="static/img/act/5/2.jpg"  />
      <img src="static/img/act/5/3.jpg"  />
      <img src="static/img/act/5/footer.jpg" />
      <div class="bottom"></div>       
      <!-- 缩略图 -->  
      <div class="btn btn-1-1" @click="displayPhoto(1)"></div>
      <div class="btn btn-1-2" @click="displayPhoto(2)"></div>
      <div class="btn btn-1-3" @click="displayPhoto(3)"></div>
      <div class="btn btn-1-4" @click="displayPhoto(4)"></div>
      <div class="btn btn-1-5" @click="displayPhoto(5)"></div>
      <div class="btn btn-1-6" @click="displayPhoto(6)"></div>
      <div class="btn btn-1-7" @click="displayPhoto(7)"></div>
      <div class="btn btn-1-8" @click="displayPhoto(8)"></div>
      <div class="btn btn-1-9" @click="displayPhoto(9)"></div>
      
      <div class="btn btn-2-1" @click="displayPhoto(10)"></div>
      <div class="btn btn-2-2" @click="displayPhoto(11)"></div>
      <div class="btn btn-2-3" @click="displayPhoto(12)"></div>
      <div class="btn btn-2-4" @click="displayPhoto(13)"></div>
      <div class="btn btn-2-5" @click="displayPhoto(14)"></div>
      <div class="btn btn-2-6" @click="displayPhoto(15)"></div>
      <div class="btn btn-2-7" @click="displayPhoto(16)"></div>
      <div class="btn btn-2-8" @click="displayPhoto(17)"></div>
      <div class="btn btn-2-9" @click="displayPhoto(18)"></div>
      <!-- 缩略图 end -->  

    </div>
  
 
  </div>
  

</template>
 

<script>
  import { Tabbar, TabbarItem  } from 'vant';
  import { ImagePreview } from 'vant';
  //动画
  import Velocity from 'velocity-animate'

  export default {
    name: 'Act5Main',
    components: {      
      'van-tabbar':Tabbar,
      'van-tabbar-item':TabbarItem,
      'van-image-preview':ImagePreview,
    },
    data() {
      return {    
        preview:'',
        icon: {
          news:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAk1BMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ROyVeAAAAMHRSTlMAlPZUiBYTCwd/N/ny5Ne5hW1dA+jdxLCon09MSB7IvZd1KxoQ0MybjT4nIu+jeFORuveCAAABOElEQVRIx+3TyY6CQBSF4RIp5kmUQRClcban8/5P13bSJA3UcE1c+m1Y/dG6dYs9j+VGfuRyRmfvgADYHeiJiSDZuAEu5GJ5gnv/uDiSEydCff9UyJbkJkfBGS+wZWTeCnESY3WljzgN8SusqX9skeOPEX+TfmKNfwxXXxxKDJmEWxxbaIrax9jKUy9XgalWmWx8TIUe/SS9N0WxzyFSKm7U+4BI1MmTOYT8jWJVIJbKkwR48PzLGcQSaeKsIXaRr2QBsbM0uUUQ23HyuvSMq25g9JG9Z5DZNuqLpF9mc4RcvhclXxggPGcvwID+OVsx1GJrvCsmdExnNGDo3YYJz6CTjYfWme1MpTU79kx2lc57aeVQEucMo4c1KWHNFr1Tw2h4/6A/Of04dRkGYVnZD83A4pbNXiZ+AA/MjfQ1ch3CAAAAAElFTkSuQmCC',
          newsActive:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAhFBMVEUAAAAAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUNCnCUgAAAAK3RSTlMAlPWHVIBKFhMLBzfw6NfOxbltXU8D+OTdvbCoHhqfl3UrEKObiz4nInhT9xpwsgAAAS5JREFUSMftk8lugzAURQkOmHmeIVAytr3//39NpURqDLYfUpY9G6+O7HfftfE+HCuqIotvMNwWCID2SFcYAmZbAS5ko4xh3Q8LMVnxItj3o0BTkp0EHTd4h8Qg44dIWYrwSo84D/FLbVMfliV4YKbfpCtG/MG09MaxxyuMsEWRTGPYFURCX12uDkumrZcAta+bZMmHwji0WKMvFUUJsEY0y5U9VqlsRVWwTq6fnj5/uZMo8qJ5o0S5yCvZSZSzVLlFEqU9SOsCCeZVFxg9ss8GMuJBvUj6MocYcpLVAL6gItO2mPKdnRRqUkfsCoMO5gkBQ8/tVeENdDRiaDObdiomNhvvxC3y/ZO88CiKd4b5BCNJMYZEqCMBfnoYJ75hnL42675wN2XgcMc1/lnwAx0Vf289P+91AAAAAElFTkSuQmCC',
          maps:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAmVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////VHQRUAAAAMnRSTlMAwHD9CQb69u6VRBoC6cSsnIRIL+HcuLF5amE5Hw3JvYh/XM+mV1Q+PBHk14w0JhTwTNaxRx0AAAGbSURBVEjH7ZXpcoIwFIVTwqYgoOwgivtWa3vf/+GahMgQHRKcaf95fuUw55sk914m6K/kZMsJ4Cgt9IGAXlvANSmGbbGBjraGmrjFICh1lUgCD1qpiF17DZsvzLkC4RcZOQiFCV/LiS9gyhrnN/vJkTULRQYvnsms/GSZeJQFswcpsmKZz7tdDkAKlvG4M2xmQ+7KpzkZVwgdgWncPSbWSfyYJRaI8alnwh6hE2Ype0Y+unljLmS9pYsOQuNUAb8w1SbYRtD2xbUfEOA6UxyeRHYsoQeBK++loAlpUt2LTHldqYSPUS9ydhGaPRCWQ+vYiwAtlNe6tq2BBEmIK7FwkxOpvCVBgDZ41EV2bIpkiE9sFYvesaTIB/Vhm4kr9teoEVRw9x0So4EaaU9v0uncYzVS6rwEeIeIPkCNaInBGLxGgxFIKZOz+R+KwFJHTON8MAKLGyMsbTgClzmplQmvIGAfcgyvIUCAVxF4I/+CREFBml791Av8jNipdhWROFh3HqtqVnsmR5p4KL7lJO60RngNcoR8n8bfuusXYnzRamp4tGoAAAAASUVORK5CYII=',
          mapsActive:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAjVBMVEUAAAAAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUPLF8SZAAAALnRSTlMAwHD7Cgbv6ayViYNJRBycPS8Q4dzFsXxqYVY5+PTKvbhc0CAY5NemdTQmw7pSNoULQAAAAYhJREFUSMftldlygkAQRW8cQEQEARdWRU1csvT/f15mi3G0hLEqD3nwPHGr+tR090CBv+L1uB4SyxaFYyk4QU2aYWFlRFu6wHctmpqRwaJf+aQrln1GeR7DI0UdoRs9yIjXJa1+7jbejWZ8dV63siFB5upVMBl3ncrSbGUl49RCCaBZWygFCeY6uWpriU4VrnAmKTAlyQSSowzM4eXTZduQWT6eMyqBVCleCE7OZNjzxwMJcEaUC2I5sGIbHzL6vRfvSiHNm9DphhCo6I5CJ3WXJkMXCO4qgdqryRhAdkdRnYVkUkdqj6ZitI0PEhgnxx1Ky1NlTpICadOhUMXj6FIp5Ra7FJ9HZ2bmqOlUXkROatLMUvnV9CsodPISHgZko+jumXg7S9avVI5eASvBeaF+ZdC60mEbWCu0EE4e4gGF1g4kk9xaoVUqjWZgr9B+B3wxekSh4TRnZK/88FT+h5LFRQQ4YbBit4q3GJxMZRZvdtBIbc60osoTGPDyCBrzb5ADvs/Ln5z5Bm8qwARlKqWAAAAAAElFTkSuQmCC',
          pay:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAApVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+4/eNVAAAANnRSTlMA78kP+Xb1ChJMLuFyM/LYhc2WkRgU7NzTw7scv7Sgm459WLqmgVMGA/vlrFwpIaNsY0I5AsgkhPa7AAABt0lEQVRIx+3VyXaqQBCA4UJomVFQGSIzAs5TTL//o90iN8G0oMjJJicn/8YF/UkVC4DWSlHRslFYTEV4ruXuGKgGpYLtWrJ0ga4uOy1wOPqRsDYtmX8IFG3j2pRJUL3JXaWTjfl5nlWOH8tS8//JYsDRu61GwfgsMkKMaGemzpJ0Y3cIL9l/AXtcb3o6rB8AP6nucV0otooZAL9dqO3nBT9X8NhrMqmJS9eWPMXxtgunCYZevgMoX4lJhZoM8AIXyXOAZXGLjLccdxB1BHiIIXjxUCGQF86qBtwgmb8Dl9ImwYabajw4h6rwAUg1rpKMKL1DEAXFrFo0QmSY/0GOoz4giLKUx510y9MQlMpYXdEOgjv5W0SitISLElcjdhLM9k6IQLcY0CQsikU4ugieJzTgwaK0L5kI/UjWn7z8LhIPe5NxT+L1JwPpJxCzP3nrT05uG0mMxhstrAl+58wmIdwtkOdwrVQ09hm4t8SIELAtdc2j10YzhnA1YNM1v53YVjEFrB29rBpkHaUSPEgh2ZAhapjy0NGOZMY70fDHCVMRnmhPfA7JkVMPCJ5sTnIezvG2hL++3z/3mf8b8/frVAAAAABJRU5ErkJggg==',
          payActive:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAjVBMVEUAAAAAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUPLF8SZAAAALnRSTlMA7snxD/l29QqQLRLh1rtMAnIyhX6WHducGBTMolkFwrS/plP75qxoXtBCOSTENdtAswAAAahJREFUSMft1clugzAQBuAhBocdTNgS9pB94f0fr+O2QYApCcqlUvtfEPJ89pgDA6PJVZ3ZVlyvVRdeiZvfWGmSplEkK3AM9znQWRlJzXeUfRI48iTQ2cF61D+Uedd+Uq5HD8mjvq+iSnMMcX+6XbT1YnZWubqoPaHGzdMkXp9kB+mJKPywA0K83vqU7idA5fMzjJZoQb0BkE9bc7xeqXwdwL36WkvOzT5w1tjeaRuJYFlwkF9p0igtWeCCFDshLtRDRBb+DTfz6JkX9Qguphy5zjbadUH4CSx8EQm2cODtwSU1lS+QUN6u7uPJInmgst7wi8aIWoAfZYIgsjMZkRcUDEGur8xdM00wpOBINVxwdY23+Jzgyv2ICLygA0QyRJoKRwvB66QpZQjwMZco84gtg/bHyXI2Wc0kxXyyMH4DSV4l5J1TjtYY8YnwR0tbgnPuLBJKhsAJu9PRY/3urCEhMYLhRGJFl2x6ROJgJB6rxokU1GvAjCN7J5B9nBmTA5bayx4x40wcriLC2mgDjCBIMxVeyI1WEpIjEcBEQrqS4aKdcvjP+/kAad3aBPB8MKUAAAAASUVORK5CYII=',
          service:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAnFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+TINBkAAAAM3RSTlMA/d3n7jP54qsDnnTVjC8rEgzq2MbAknhiU00XBvPMvLezhG5qCKNwV0pFKCLwmW9bUDzedV2fAAABe0lEQVRIx+2UaXOCMBCGCYT78EIOURTB+2z3//+3UjNqrFlNZjr91OcjycM7s9ld7RfpONTZKRluAkASV0XZ6AAw2KqEeKRVyFFB+bAB1GLGS3JRiOcqhgDoI5UQtZh1G6IW03PITSHLsYxyNuCOnUuFAAdxFq+vd6NR41HgocdmFHUFdwszP4VOHOgGJfCIRQ09iJ2wzs3idt/0yvbuwYJXWIfWLL2IKVOQhsyYQkEegykJkU8JmVIkRNoorrUNLSnDmt+r3Z1PJIxJ2uOf3H/v0NNjIyyad3XrZ+OfQ5IZr6ubPY+Oe7YBx14Lhy3XUWOAjVpmoBkawqeOhZiY0vTRamFKaKHPjikVYDjY1JeoEiMboDNAlWAvVnIDf8mNWEnx1qS1WPEIN0zVfMaXLBErQ24r1HttV3N7ZCbee8H1fLrasXr4t7+UPaxdmNBhH3hJF7bM5tIuQ78VOKI0vrTMVqTsq1ZIo6fv5rdUFZoI019FyIFvav/8IV99d7R9wunqRgAAAABJRU5ErkJggg==',
          serviceActive:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAh1BMVEUAAAAAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUMAkUNRyTtJAAAALHRSTlMA3ecz+e7ivqtvBwOedFIM1caMeCsS8urYkmpNLxfMt7OEYqNXSkUoIplbPKNgyhcAAAFnSURBVEjH7dPZcoIwFAZgSFgS9kVQEBCpe8/7P1/VDJrWHCQznV71v0zyzT9zkhi/mAWz2VFL+BUAVL4O2ZtXsjrolARwy1mDRA6AXo33ASKBr1EiYq41SjRrdqJEoyZm8MyHN4dciEScSKdEhL2pKZp1HdjfiH2u102hONvSiGcsTUwigBTLJmaSsoxHtH2cp0F3PVtaMBWrvMouoIK4MD8bQWwNQgSpNEgmSFvNF+0428yaBaztc9rFdo4p81i+8rB8K2wuxBivtt+IZe39/CQDmRRkeP06/sWZEM7OV/5fExUr7KsNBO0wkHyaWAnFSL3EpjVgJLPQa8dID1gYIuIOJamnJosVSpKTmkQEJc5eTfJy4kmqSQBS+u1GHlmlJi48suEn48jlBaUoknHf5Ucxj/CBunjqubjhQizIyKQqsl/eQS7AmCZP70/moCKnHiDNm5d1ekN9a6hCQ94gGyE1/vOH+QI5bZ6m5Agn7wAAAABJRU5ErkJggg==',
        },  
      }
    },
    mounted() {      
     },
    created() {  
      this.setDocumentV2(
        "三江狂野斗牛",
        "",
        "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/5/share.jpg?v=2"
      );
      _czc.push(['_trackEvent', '三江狂野斗牛', '点击', '活动主页面','0','5']);
    },
    methods: {
      back(){
        if(this.$router.go(-1)){
          console.log("aaaaaaaaaa")
        }
      },
      displayPhoto(id) {
        this.preview = ImagePreview({
          images: [ 'static/img/act/5/photo/' + id + '.jpg' ],
          showIndex:false,
         });
      },
    }
  }
</script>

<style scoped>
  .main{
    position: relative;
  }
  .main img{
    width: 100%;
    border: 0;
    vertical-align: middle
  }
  .bottom{
    height: 1.37rem;
  }
  
  .btn {
    position: absolute;
    width: 27%;
    height: 5.76%;
  }
  .btn-1-1 {
    top: 34%;
    left: 15%;
  }
  .btn-1-2 {
    top: 34%;
    left: 42.5%;
  } 
  .btn-1-3 {
    top: 34%;
    left: 70.5%;
  } 
  
  .btn-1-4 {
    top: 40%;
    left: 15%;
  } 
  .btn-1-5 {
    top: 40%;
    left: 42.5%;
  } 
  .btn-1-6 {
    top: 40%;
    left: 70.5%;
  } 
  
  .btn-1-7 {
    top: 46%;
    left: 15%;
  } 
  .btn-1-8 {
    top: 46%;
    left: 42.5%;
  } 
  .btn-1-9 {
    top: 46%;
    left: 70.5%;
  } 

  
  .btn-2-1 {
    top: 66%;
    left: 15%;
  } 
  .btn-2-2 {
    top: 66%;
    left: 42.5%;
  } 
  .btn-2-3 {
    top: 66%;
    left: 70.5%;
  } 
  
  .btn-2-4 {
    top: 72%;
    left: 15%;
  } 
  .btn-2-5 {
    top: 72%;
    left: 42.5%;
  } 
  .btn-2-6 {
    top: 72%;
    left: 70.5%;
  } 
  
  .btn-2-7 {
    top: 78%;
    left: 15%;
  } 
  .btn-2-8 {
    top: 78%;
    left: 42.5%;
  } 
  .btn-2-9 {
    top: 78%;
    left: 70.5%;
  } 
</style>


// WEBPACK FOOTER //
// src/components/act/5/main.vue